import i18n from '@/lang';
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.object.to-string.js";
export default [{
  path: '/mine',
  name: 'Mine',
  component: function component() {
    return import('@/pages/mine/entry');
  },
  meta: {
    name: i18n.tc("119")
  }
}, {
  path: '/mine/updatePwd',
  name: 'UpdatePwd',
  component: function component() {
    return import('@/pages/mine/updatePwd');
  },
  meta: {
    name: i18n.tc("137")
  }
}, {
  path: '/mine/address/list',
  name: 'AddressList',
  component: function component() {
    return import('@/pages/mine/address/list');
  },
  meta: {
    name: i18n.tc("138")
  }
}, {
  path: '/mine/address/list/add',
  name: 'AddressAdd',
  component: function component() {
    return import('@/pages/mine/address/add');
  },
  meta: {
    name: i18n.tc("139")
  }
}, {
  path: '/mine/grouplist',
  name: 'GroupList',
  component: function component() {
    return import('@/pages/mine/groupList/entry');
  },
  meta: {
    name: i18n.tc("140")
  }
}, {
  path: '/mine/grouplist/person/:id',
  name: 'GroupPerson',
  component: function component() {
    return import('@/pages/mine/groupList/person');
  },
  props: true,
  meta: {
    name: i18n.tc("141")
  }
}, {
  path: '/mine/doc',
  name: 'DOC',
  component: function component() {
    return import('@/pages/mine/doc/entry');
  },
  props: true,
  meta: {
    name: i18n.tc("142")
  }
}, {
  path: '/mine/doc/docDetail/:id',
  name: 'DOCDetail',
  props: true,
  component: function component() {
    return import('@/pages/mine/doc/detail');
  },
  meta: {
    name: i18n.tc("143")
  }
}, {
  path: '/mine/faq',
  name: 'FAQ',
  component: function component() {
    return import('@/pages/mine/faq');
  },
  props: true,
  meta: {
    name: 'FAQ'
  }
}, {
  path: '/mine/faq/faqDetail/:id',
  name: 'FAQDetail',
  props: true,
  component: function component() {
    return import('@/pages/mine/faq/detail');
  },
  meta: {
    name: i18n.tc("144")
  }
}, {
  path: '/product/detail/:code',
  name: 'Product',
  props: true,
  component: function component() {
    return import('@/pages/mine/product');
  },
  meta: {
    name: i18n.tc("145")
  }
}];